<template>
  <base-layout  page-default-back-link="/home"  >
    <div style="padding-top: 5px">
      <span style="font-size: 15px; padding: 10px;">{{$t('Quanto tempo hai ?')}}</span>
    </div>
    <ion-row>
      <ion-col v-for="item in arcPulsantiTempo" :key="item.Att_cat2" size-xs="6" size-lg="4" size-md="4" size-sm="4">
        <router-link :to="{ name: 'AttivitaLista', params: { pSearch: item.Att_cat2 } }">
          <ion-button v-html="item.Att_cat2" style="width: 100%"></ion-button>
        </router-link>
      </ion-col>
    </ion-row>
    <div style="padding-top: 5px">
      <span style="font-size: 15px; padding: 10px;">{{$t('Cosa vorresti fare ?')}}</span>
    </div>
    <ion-row>
      <ion-col v-for="item in arcPulsantiTipo" :key="item.Att_cat1" size-xs="6" size-lg="4" size-md="4" size-sm="4">
        <router-link :to="{ name: 'AttivitaLista', params: { pSearch: item.Att_cat1 } }">
          <ion-button v-html="item.Att_cat1" style="width: 100%"></ion-button>
        </router-link>
      </ion-col>
    </ion-row>
  </base-layout>
</template>

<script>
import { BaseLayout, IonButton, IonRow, IonCol } from "@ionic/vue";
import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";

export default {
  name: "HomePageAttivita",
  components: {
    BaseLayout,
    IonButton,
    IonRow,
    IonCol,
  },
  data() {
    return {
      arcPulsantiTempo: [],
      arcPulsantiTipo: [],
    };
  },
  methods: {
    GetPulsanti() {
      const self = this;
      let prm = [];
      // inline

      prm.push(new CommandParam("@Lin_codi", "", DbParamType.Int32, 0, ParameterDirection.Input, this.$LIN_CODI));
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Tabella_AttivitaRicreative_Cat_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.arcPulsantiTipo = data.RecordSet.Table;
            self.arcPulsantiTempo = data.RecordSet.Table1;
          } else {
            self.arcPulsantiTempo = [];
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.GetPulsanti();
  },
};
</script>
